import React from 'react';

const SvgCalendar = () => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.2729 4.00024V2.00024V4.00024ZM15.2729 4.00024V6.00024V4.00024ZM15.2729 4.00024H10.7729H15.2729ZM3.27295 10.0002V19.0002C3.27295 20.1048 4.16838 21.0002 5.27295 21.0002H19.2729C20.3775 21.0002 21.2729 20.1048 21.2729 19.0002V10.0002H3.27295Z"
        stroke="white"
        strokeWidth="1.52071"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.27271 10V6C3.27271 4.89543 4.16814 4 5.27271 4H7.27271"
        stroke="white"
        strokeWidth="1.52071"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.27295 2.00024V6.00024"
        stroke="white"
        strokeWidth="1.52071"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.2729 10V6C21.2729 4.89543 20.3775 4 19.2729 4H18.7729"
        stroke="white"
        strokeWidth="1.52071"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SvgCalendar;
